/**
 * filter unique values in array.
 */
export const unique = (source: unknown[]): unknown[] => {
    const set = new Set(source);

    return [...set];
};
